import { EntityTypes } from '../../utilities/Constants';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetChildDocuments = (reportGuid: string, enabled: boolean) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-child-documents', { reportGuid }],
        queryFn: async () => {
            const response = await zoneApiClient.getCollabReportChildren(reportGuid, EntityTypes.Report);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve Child Documents.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled
    });
};
